import FormWrapper from "../FormWrapper/FormWrapper";
import DropDown from "../../Shared_components/DropDown";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const WhereToGo = ({ route, fetchedFormData, updateFields, routesLoading }) => {
  const { Route } = fetchedFormData; // fetcherd data form server

  const query = useQuery();
  const token = query.get("token");

  useEffect(() => {
    if (token) {
      // Store the token in local storage or state

      sessionStorage.setItem("authToken", token);
      // Redirect or load protected data
    }
  }, [token]);

  return (
    <div className=" w-full  mx-auto flex justify-center lg:justify-center items-center  h-full px-4 lg:px-0">
      <div className="w-full px-0 sm:px-4">
        <DropDown
          required={true}
          alltimeValue={route}
          valueUpdate={(e) => updateFields({ route: e.target.value })}
          placeHolder={routesLoading ? "Loading routes..." : "Select a route"}
          disabled={routesLoading}
        >
          {routesLoading ? (
            <option value="" disabled>Loading routes...</option>
          ) : Route && Route.length > 0 ? (
            Route.map((item) => (
              <option value={item.id} key={item.id}>
                {item.routeName}
              </option>
            ))
          ) : (
            <option value="" disabled>No routes available</option>
          )}
        </DropDown>
      </div>
    </div>
  );
};

export default WhereToGo;
